import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CustomDatePicker from '../../util_components/custom_date_picker';
import { RANGE_OPTIONS, readPeriodParams, resolvePeriod, buildPeriodSearch } from './period_utils';
import './trial_points.css';

// URL-controlled period picker shared by the /trial_points pages. The URL is the single source
// of truth: this component only reads and writes it; pages derive the period from the URL too.
function PeriodFilter() {
  const history = useHistory();
  const location = useLocation();
  const { range, customStart, customEnd } = readPeriodParams(location.search);
  const { startDate, endDate } = resolvePeriod(range, customStart, customEnd);

  const updateUrl = (nextRange, nextStart, nextEnd) => {
    history.replace({
      pathname: location.pathname,
      search: buildPeriodSearch(location.search, nextRange, nextStart, nextEnd)
    });
  };

  const onRangeChange = (e) => {
    const next = e.target.value || 'this_month';
    // Switching to custom pre-fills the currently resolved period so both dates are always set.
    if (next === 'custom') updateUrl('custom', startDate, endDate);
    else updateUrl(next, '', '');
  };

  return (
    <div className="tp-filter">
      <span style={{ color: 'var(--text-primary)', fontWeight: 700, fontSize: '16px' }}>
        Period:
      </span>
      <select
        value={range}
        onChange={onRangeChange}
        style={{
          background: 'var(--input-bg)',
          color: 'var(--input-text)',
          border: '1px solid var(--input-border)',
          borderRadius: '8px',
          height: '44px',
          padding: '0 36px 0 14px',
          fontSize: '15px',
          width: '240px' // explicit: some legacy styles stretch bare selects
        }}
      >
        {RANGE_OPTIONS.map((o) => (
          <option value={o.value} key={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {range === 'custom' ? (
        <>
          <CustomDatePicker
            label="Start date"
            value={customStart}
            maxDate={customEnd}
            handleChange={(d) => updateUrl('custom', d, customEnd)}
          />
          <CustomDatePicker
            label="End date"
            value={customEnd}
            minDate={customStart}
            handleChange={(d) => updateUrl('custom', customStart, d)}
          />
        </>
      ) : null}
      <div style={{ color: 'var(--text-secondary)', fontSize: '16px' }}>
        {startDate} to {endDate}
      </div>
    </div>
  );
}

export default PeriodFilter;
